<template>
    <div class="pack-box gift-choice gift-choice__tableau ">
        <div class="pack-title">

            <img src="/images/fr_new_home/cadeau.svg" alt="cadeaux"/>
            <h3>
                Kies je <span class="orange-text"> geschenk</span>
            </h3>
        </div>
        <h6 class="text-uppercase orange-text">Krijg toegang tot een uitgebreide catalogus met geschenken</h6>
        <p>
            Consumeren gaat gepaard met keuzevrijheid. Testaankoop laat je daarom zelf je geschenk kiezen uit een
            uitgebreide catalogus.
        </p>
        <div class="tableau">
            <div class="tableau-title-container">
                <p class="tableau-title">Een paar voorbeelden van cadeau’s </p>
<!--                <p class="product-offre tableau-title">Aanbod</p>-->
                <p class="product-price tableau-title">Prijs</p>
            </div>
            <div class="product-row" v-for="elem in tableau">
                <p class="product-name" v-html="elem"></p>
<!--                <p class="product-offre">€2/2 maanden</p>-->
                <p class="product-price">GRATIS</p>
            </div>
            <div class="product-row">
                <p class="product-name">LENOVO tablet <span>+ transparante hoes</span>
                    <svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="0.-Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Home-PremiumTablet-BlackFriday" transform="translate(-1226.000000, -1385.000000)"
                               fill="#FF8600">
                                <g id="compo_home_texte" transform="translate(15.000000, 842.000000)">
                                    <g id="Right-bloc" transform="translate(987.000000, 206.000000)">
                                        <g id="Tableau" transform="translate(0.000000, 161.000000)">
                                            <polygon id="Star"
                                                     points="231 186.5 226.885503 188.663119 227.671302 184.081559 224.342604 180.836881 228.942752 180.168441 231 176 233.057248 180.168441 237.657396 180.836881 234.328698 184.081559 235.114497 188.663119"></polygon>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </p>
<!--                <p class="product-offre">€2/2 maanden</p>-->
                <p class="product-price">€92,40*</p>
            </div>
            <p class="asterix">* LENOVO Tablet: Persoonlijke bijdrage van € 92,40 nodig. Voor betaling is creditcard vereist</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "GiftChoiceTableauLenovo",
    data() {
        return {
            tableau: [
                `Koffiezetapparaat <span> capsule-compatibel </span> `, "KOPTELETOON JBL", "Robotstofzuiger", "SmartWatch GTS4",
            ],
        }
    },

}
</script>

<style scoped>

</style>
